import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "@/store/index";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

function getUTMParameters() {
  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get("utm_source");
  const utmMedium = params.get("utm_medium");
  const utm_campaign = params.get("utm_campaign");
  const utm_content = params.get("utm_content");
  const utmId = params.get("utm_id");
  const utm_term = params.get("utm_term");

  if (utmSource) localStorage.setItem("utm_source", utmSource);
  if (utmMedium) localStorage.setItem("utm_medium", utmMedium);
  if (utmId) localStorage.setItem("utm_id", utmId);
  if (utm_campaign) localStorage.setItem("utm_campaign", utm_campaign);
  if (utm_content) localStorage.setItem("utm_content", utm_content);
  if (utm_term) localStorage.setItem("utm_term", utm_term);
}

getUTMParameters();

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Covesto";

  if (!to.meta.guest) {
    const id = localStorage.getItem("user_id");
    const verified = localStorage.getItem("verified");

    if (!(id && verified)) {
      store.state.isPrivate = false;
      // store.state.Auth.checkStatus = "LOGIN";
      router.push({ name: "login" });
    } else {
      store.state.isPrivate = false;
    }
  }

  // Append UTM parameters to the query if they exist in local storage
  const utmSource = localStorage.getItem("utm_source");
  const utmMedium = localStorage.getItem("utm_medium");
  const utmId = localStorage.getItem("utm_id");
  const utmCampaign = localStorage.getItem("utm_campaign");
  const utmContent = localStorage.getItem("utm_content");
  const utmTerm = localStorage.getItem("utm_term");

  if (utmSource || utmMedium || utmId) {
    const query = { ...to.query };
    if (utmSource) query.utm_source = utmSource;
    if (utmMedium) query.utm_medium = utmMedium;
    if (utmId) query.utm_id = utmId;
    if (utmCampaign) query.utm_campaign = utmCampaign;
    if (utmContent) query.utm_content = utmContent;
    if (utmTerm) query.utm_term = utmTerm;

    // Prevent infinite redirect loop
    if (JSON.stringify(to.query) !== JSON.stringify(query)) {
      return next({ path: to.path, query });
    }
  }

  next();
});

export default router;
